import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import image from "../../assets/image/topbar/Indian_Flag.svg.png"
const TopBar = () => {
  return (
    <div className={clsx("container p-2")}>
      <div className={clsx("row align-items-center justify-content-between")}>

        {/* Social Links */}
        <div className={clsx("col-md-5 col-12 d-flex flex-wrap align-items-center gap-3 justify-content-center justify-content-md-start")}>
          <a href={"https://www.facebook.com/09MobileGallary/"} target="_blank"
            rel="noopener noreferrer" className={clsx("text-uppercase fs-[14px] fw-semibold hover:text-blue-500")}>Facebook</a>
          <span className="d-none d-md-inline">|</span>
          <a href={"https://www.instagram.com/09mobile.gallery/"} target="_blank"
            rel="noopener noreferrer" className={clsx("text-uppercase fs-[14px] fw-semibold hover:text-blue-500")}>Instagram</a>
          <span className="d-none d-md-inline">|</span>
          <a href={"https://www.youtube.com/@09mobilegallery"} target="_blank"
            rel="noopener noreferrer" className={clsx("text-uppercase fs-[14px] fw-semibold hover:text-blue-500")}>YouTube</a>
          <span className="d-none d-md-inline">|</span>
          <a href={"https://www.linkedin.com/in/zero-nine-mobile-gallery-a362b7346/"} target="_blank"
            rel="noopener noreferrer" className={clsx("text-uppercase fs-[14px] fw-semibold hover:text-blue-500")}>LinkedIn</a>
        </div>

        {/* Delivery Info (Centered on Small Screens) */}
        <div className={clsx("col-md-2 col-12 text-center text-uppercase fs-[14px] fw-semibold text-gray-700 mt-2 mt-md-0")}>
          Free Delivery in SURAT
        </div>

        {/* Support Links */}
        <div className={clsx("col-md-5 col-12 d-flex flex-wrap align-items-center justify-content-center justify-content-md-end gap-3 mt-2 mt-md-0")}>
          <Link to={"/"} className={clsx("text-uppercase fs-[14px] fw-semibold hover:text-blue-500 d-flex align-items-center")}>
            <img alt='' src={image} className={clsx("p-1 me-1")} />
            India
          </Link>
          <span className="d-none d-md-inline">|</span>
          <a href={"https://chat.whatsapp.com/KmonIba0CslEpxaSljHbga"} target="_blank"
            rel="noopener noreferrer" className={clsx("text-uppercase fs-[14px] fw-semibold hover:text-blue-500")}>Help Center</a>
          <span className="d-none d-md-inline">|</span>
          <Link to={"/orders"} className={clsx("text-uppercase fs-[14px] fw-semibold hover:text-blue-500")}>Track Order</Link>
        </div>

      </div>
    </div>

  );
};

export default TopBar;